var _excluded = ["palette", "cssVariables", "colorSchemes", "defaultColorScheme"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import createPalette from "./createPalette.js";
import createThemeWithVars from "./createThemeWithVars.js";
import createThemeNoVars from "./createThemeNoVars.js";
export { createMuiTheme } from "./createThemeNoVars.js";
// eslint-disable-next-line consistent-return
function attachColorScheme(theme, scheme, colorScheme) {
  if (!theme.colorSchemes) {
    return undefined;
  }
  if (colorScheme) {
    theme.colorSchemes[scheme] = _objectSpread(_objectSpread({}, colorScheme !== true && colorScheme), {}, {
      palette: createPalette(_objectSpread(_objectSpread({}, colorScheme === true ? {} : colorScheme.palette), {}, {
        mode: scheme
      })) // cast type to skip module augmentation test
    });
  }
}

/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */
export default function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var palette = options.palette,
    _options$cssVariables = options.cssVariables,
    cssVariables = _options$cssVariables === void 0 ? false : _options$cssVariables,
    _options$colorSchemes = options.colorSchemes,
    initialColorSchemes = _options$colorSchemes === void 0 ? !palette ? {
      light: true
    } : undefined : _options$colorSchemes,
    _options$defaultColor = options.defaultColorScheme,
    initialDefaultColorScheme = _options$defaultColor === void 0 ? palette === null || palette === void 0 ? void 0 : palette.mode : _options$defaultColor,
    rest = _objectWithoutProperties(options, _excluded);
  var defaultColorSchemeInput = initialDefaultColorScheme || 'light';
  var defaultScheme = initialColorSchemes === null || initialColorSchemes === void 0 ? void 0 : initialColorSchemes[defaultColorSchemeInput];
  var colorSchemesInput = _objectSpread(_objectSpread({}, initialColorSchemes), palette ? _defineProperty({}, defaultColorSchemeInput, _objectSpread(_objectSpread({}, typeof defaultScheme !== 'boolean' && defaultScheme), {}, {
    palette: palette
  })) : undefined);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (cssVariables === false) {
    if (!('colorSchemes' in options)) {
      // Behaves exactly as v5
      return createThemeNoVars.apply(void 0, [options].concat(args));
    }
    var paletteOptions = palette;
    if (!('palette' in options)) {
      if (colorSchemesInput[defaultColorSchemeInput]) {
        if (colorSchemesInput[defaultColorSchemeInput] !== true) {
          paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
        } else if (defaultColorSchemeInput === 'dark') {
          // @ts-ignore to prevent the module augmentation test from failing
          paletteOptions = {
            mode: 'dark'
          };
        }
      }
    }
    var theme = createThemeNoVars.apply(void 0, [_objectSpread(_objectSpread({}, options), {}, {
      palette: paletteOptions
    })].concat(args));
    theme.defaultColorScheme = defaultColorSchemeInput;
    theme.colorSchemes = colorSchemesInput;
    if (theme.palette.mode === 'light') {
      theme.colorSchemes.light = _objectSpread(_objectSpread({}, colorSchemesInput.light !== true && colorSchemesInput.light), {}, {
        palette: theme.palette
      });
      attachColorScheme(theme, 'dark', colorSchemesInput.dark);
    }
    if (theme.palette.mode === 'dark') {
      theme.colorSchemes.dark = _objectSpread(_objectSpread({}, colorSchemesInput.dark !== true && colorSchemesInput.dark), {}, {
        palette: theme.palette
      });
      attachColorScheme(theme, 'light', colorSchemesInput.light);
    }
    return theme;
  }
  if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') {
    colorSchemesInput.light = true;
  }
  return createThemeWithVars.apply(void 0, [_objectSpread(_objectSpread({}, rest), {}, {
    colorSchemes: colorSchemesInput,
    defaultColorScheme: defaultColorSchemeInput
  }, typeof cssVariables !== 'boolean' && cssVariables)].concat(args));
}